import { Box, Button } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';

const MobileMapToggle = ({ expandMap, handleExpandMap }) => {
  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', mt: 1 }}>
      <Button onClick={() => handleExpandMap(!expandMap)}>
        {expandMap ? (
          <>
            Reducir mapa <ExpandLessIcon />
          </>
        ) : (
          <>
            Ampliar mapa <ExpandMoreIcon />
          </>
        )}
      </Button>
    </Box>
  );
};

export default MobileMapToggle;
